import { render, staticRenderFns } from "./LogicCashTodayDetailLastTransactions.vue?vue&type=template&id=15ca4c34&scoped=true&"
import script from "./LogicCashTodayDetailLastTransactions.vue?vue&type=script&lang=ts&"
export * from "./LogicCashTodayDetailLastTransactions.vue?vue&type=script&lang=ts&"
import style0 from "./LogicCashTodayDetailLastTransactions.vue?vue&type=style&index=0&id=15ca4c34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ca4c34",
  null
  
)

export default component.exports